import { render, staticRenderFns } from "./PaymentAnnouncement.vue?vue&type=template&id=2c173a61&scoped=true"
import script from "./PaymentAnnouncement.vue?vue&type=script&lang=js"
export * from "./PaymentAnnouncement.vue?vue&type=script&lang=js"
import style0 from "./PaymentAnnouncement.vue?vue&type=style&index=0&id=2c173a61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c173a61",
  null
  
)

export default component.exports